import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "website-input" }
const _hoisted_2 = { class: "website-input__label" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "website-input__main" }
const _hoisted_5 = { class: "website-input__text" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "website-input__dropdown-item-text" }

import { computed, ref, onMounted } from 'vue';

import { urlProtocols, urlProtocolSeparator } from '@/helpers/utils';

import DropdownArrow from './DropdownArrow.vue';
import TextInput from './TextInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteInput',
  props: {
  placeholder: {
    type: String,
    default: 'www.bellalite.se',
  },
  maxHeight: {
    type: Number,
    default: 300,
  },
  errorMessage: {
    type: String,
  },
  value: {
    type: String,
  },
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
},
  emits: ['focus', 'blur', 'input', 'enter-key-pressed'],
  setup(__props, { emit }) {

const props = __props;





const inputEl = ref<HTMLInputElement | null>(null);

const showDropdown = ref(false);
const selectedProtocolIndex = ref<number>(0);
const website = ref<string | undefined>('');
const websiteProtocols = ref([urlProtocols.https, urlProtocols.http]);

const fullWebsiteUrl = computed(() => {
  return `${
    websiteProtocols.value[selectedProtocolIndex.value] + urlProtocolSeparator
  }${website.value || ''}`;
});

onMounted(() => {
  if (!props.value) {
    return;
  }
  if (!hasProtocolPrefix(props.value)) {
    website.value = props.value;
    return;
  }
  const [selectedProtocolUrl, restOfUrl] = props.value?.split(/:\/\//);

  selectedProtocolIndex.value =
    websiteProtocols.value.indexOf(selectedProtocolUrl);
  website.value = restOfUrl || '';
});

function toggleDropdown() {
  showDropdown.value = !showDropdown.value;
}

function isCurrent(index: number) {
  return selectedProtocolIndex.value === index;
}

function selectProtocol(index: number) {
  selectedProtocolIndex.value = index;

  emit('input', fullWebsiteUrl.value);
  toggleDropdown();
}

function onInput(value: string) {
  website.value = value;
  emit('input', fullWebsiteUrl.value);
}

function onWebsiteChanged() {
  if (!website.value) return;
  if (hasProtocolPrefix(website.value)) {
    const [selectedProtocolUrl, restOfUrl] = website.value.split(/:\/\//);

    selectedProtocolIndex.value =
      websiteProtocols.value.indexOf(selectedProtocolUrl);
    website.value = restOfUrl;
    emit('input', fullWebsiteUrl.value);
  }

  emit('blur');
}

function hasProtocolPrefix(url: string): boolean {
  for (const protocol of websiteProtocols.value) {
    if (url.startsWith(protocol)) {
      return true;
    }
  }

  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: __props.id
          }, _toDisplayString(__props.label), 9, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        tabindex: "0",
        class: "website-input__selector",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleDropdown())),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus'))),
        ref: "selector"
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(websiteProtocols.value[selectedProtocolIndex.value]), 1),
        _createVNode(DropdownArrow, { class: "website-input__dropdown" })
      ], 544),
      _createVNode(TextInput, {
        id: __props.id,
        name: __props.id,
        autocomplete: "url",
        type: "text",
        class: "website-input__text-input",
        "model-value": website.value,
        placeholder: __props.placeholder,
        "error-message": __props.errorMessage,
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (emit('focus'))),
        onBlur: onWebsiteChanged,
        onInput: onInput,
        onEnterKeyPressed: _cache[3] || (_cache[3] = ($event: any) => (emit('enter-key-pressed'))),
        ref_key: "inputEl",
        ref: inputEl
      }, null, 8, ["id", "name", "model-value", "placeholder", "error-message"])
    ]),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "website-input__dropdown-items",
          style: _normalizeStyle({ maxHeight: __props.maxHeight + 'px' }),
          ref: "dropdown"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(websiteProtocols.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item,
              class: _normalizeClass(["website-input__dropdown-item", { 'website-input__dropdown-item--selected': isCurrent(index) }]),
              onClick: ($event: any) => (selectProtocol(index))
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item), 1)
            ], 10, _hoisted_6))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})